export default {
  head () {
    return {
      script: this.gaTagBuilder
    }
  },
  methods: {
    loadGAIdByEventId (eventId) {
      const self = this
      if (!eventId) return

      this.$http.get(`public_access/analytics/${eventId}`)
        .then(function (response) {
          const responseData = response.data

          if (responseData.data) {
            self.gaId = responseData.data['google_analytics_id']
            self.$emit('updateHead')
          }
        })
    },
    loadGAIdByUrlSite (urlSite) {
      const self = this
      if (!urlSite) return

      this.$http.get(`public_access/analytics/find_by_url_site?url_site=${urlSite}`)
        .then(function (response) {
          const responseData = response.data

          if (responseData.data) {
            self.gaId = responseData.data['google_analytics_id']
            self.$emit('updateHead')
          }
        })
    },
    gaTagBuilder (params) {
      if (this.gaId && this.gaId.match(/GTM-/)) {
        let innerJS =
        `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${this.gaId}');`

        return [
          { inner: innerJS }
        ]
      } else if (this.gaId && this.pagePath) {
        let innerJS =
          `window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${this.gaId}', {'page_path': '${this.pagePath}'});`

        if (params) {
          let event = params.event
          let variableName = params.variableName
          let variableValue = params.variableValue

          innerJS = innerJS.concat(`gtag('config', '${this.gaId}', {'event': '${event}', '${variableName}': '${variableValue}'});`)
        }
        return [
          { src: `https://www.googletagmanager.com/gtag/js?id=${this.gaId}`, async: true },
          { inner: innerJS }
        ]
      } else {
        return []
      }
    }
  }
}
